<template>
    <ModalFormCard action="/actions/lead-set-status" :submittedCallback="submittedCallback" class="modal-default">
        <template #title>Mark {{ $help.pluralize('lead', update.data.length) }} as flagged</template>

        <template #default="{ saving, errors }">
            <!-- <p class="text-center text-19 font-bold px-4">
                Update {{ update.leads.length }} lead{{
                    update.leads.length > 1 ? "s" : ""
                }}
            </p> -->

            <input type="hidden" name="ids" :value="update.data" />
            <input type="hidden" name="status" :value="1" />
            <input type="hidden" name="reason" :value="update.reason" />
            <input type="hidden" name="table_multiselect_update" :value="update.tableMultiselectUpdate" />

            <div class="flex items-center">
                <IconErrorCircle />
                <p class="font-bold text-16 pl-3">Please read carefully</p>
            </div>

            <p class="text-15 pt-4">
                <b class="font-semibold">Leads should only be flagged if they aren't genuine,</b> i.e. wrong numbers, sales calls, spam
                messages, etc.
            </p>

            <p class="text-15 pt-4">
                If you weren't able to contact this lead, didn't contact this lead in time, or the lead simply didn't want to use your
                services, <b class="font-semibold">Mark as lost.</b>
            </p>

            <p class="text-15 pt-4">
                Flagged leads are used to optimise your campaigns, you must only flag leads if you're 100% sure they aren't genuine. If in
                doubt, <b class="font-semibold">Mark as lost.</b>
            </p>

            <p class="text-15 pt-4">
                If you're still unsure,
                <a href="https://support.zapo.com/en/articles/148414-flagged-vs-lost-leads" target="_blank" class="link-text font-semibold"
                    >Read this article</a
                >
            </p>

            <div class="modal-buttons">
                <ButtonSaving
                    :disabled="saving"
                    class="button-black default"
                    type="button"
                    @click="
                        () => {
                            $event.$emit('modal-open', {
                                view: 'Lost',
                                options: options,
                            })
                        }
                    "
                >
                    Mark as lost
                </ButtonSaving>

                <button class="button-purple default">Mark as flagged</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Lead from '~/models/lead.js'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        this.setup(Lead)
    },

    methods: {
        submittedCallback(res) {
            if (this.update.tableMultiselectUpdate != null) {
                this.$event.$emit('multiSelectCompleted', res.updated)
            }

            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },
    },

    computed: {
        update() {
            return this.options
        },

        ai() {
            return this.editingModel.ai_current != null ? JSON.parse(this.editingModel.ai_current.body) : false
        },
    },
}
</script>
